import { cn } from "@/utils/cn";
import { memo } from "react";

interface SettingsSectionLabelProps {
  label: string;
  className?: string;
}

export const SettingsSectionLabel = memo(function SettingsSectionLabel({
  label,
  className,
}: SettingsSectionLabelProps) {
  return (
    <p className={cn("text-[14px] font-bold leading-normal text-black", className)}>{label}</p>
  );
});
